export interface ConnectivityLogPanelProps {
  lines: string[];
  /** Show compact bar (connectivity in progress). */
  active: boolean;
  expanded: boolean;
  onToggleExpanded: () => void;
  onClear: () => void;
}

export function ConnectivityLogPanel({
  lines,
  active,
  expanded,
  onToggleExpanded,
  onClear,
}: ConnectivityLogPanelProps): JSX.Element | null {
  if (!active && !expanded && lines.length === 0) return null;

  const preview = lines.length > 0 ? lines[lines.length - 1] : 'Waiting…';

  return (
    <div
      className={`conn-log-panel${expanded ? ' conn-log-panel--expanded' : ''}`}
      aria-live="polite"
    >
      <div className="conn-log-bar">
        <button
          type="button"
          className="conn-log-toggle"
          onClick={onToggleExpanded}
          aria-expanded={expanded}
        >
          {expanded ? 'Hide connectivity log' : 'View connectivity log'}
        </button>
        {!expanded && <span className="conn-log-preview">{preview}</span>}
        {lines.length > 0 && (
          <button type="button" className="conn-log-clear btn ghost" onClick={onClear}>
            Clear
          </button>
        )}
      </div>
      {expanded && (
        <pre className="conn-log-body">
          {lines.length === 0 ? 'No events yet.' : lines.join('\n')}
        </pre>
      )}
    </div>
  );
}
